import React, { useEffect, useState, useRef } from 'react';
import styled, { css } from 'styled-components';
import Logo from './styled/Logo';
import Input from './styled/Input';
import ImageButton from './styled/ImageButton';
import Button from './styled/Button';
import { useTranslation } from 'react-i18next';
import ErrorList from './styled/ErrorList';
import DropdownList from './styled/DropdownList';
import countries from 'i18n-iso-countries';

import { useDispatch } from 'react-redux';
import { initializeForm } from '../../modules/auth';
import ValidateDiv from '../../components/auth/styled/ValidateText';
import { getIpInfo } from '../../lib/api/app';
import { registerCountryLocale } from '../../lib/countryLocales';
import MobileTop from './styled/MobileTop';
import { TabletOrDesktop } from '../../lib/responsive';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import 'flag-icon-css/css/flag-icons.min.css';
import AddressAutocomplete from './AddressAutocomplete';
import ToggleSwitch from '../common/ToggleSwitch';

const Container = styled.div`
  width: 100%;
  /* min-width: '360px'; */
  background: #eeeff0;
  .validateCss {
    margin-top: 4px;
    margin-bottom: 8px;
  }
  div {
    font-family: 'Source Sans Pro';
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
    // TODO : ACTIVATE IT FOR 2FA WITH VERIFY BUTTON
  /* Only apply top: 74% if NOT US */ 
  // &:not(.us-country) .react-tel-input .selected-flag .flag {
  //   top: 74%;
  // }

  // .react-tel-input .selected-flag .flag {
  //   top: 74%;
  // }
`;

const ContentContainer = styled.div`
  /* display: flex; */
  /* width: 100%; */
  /* align-items: center;
  justify-content: center; */
`;

const Content = styled.div`
  max-width: ${(props) => props.maxWidth};
  margin: 0 auto;
  /* display: flex; */
  /* flex-direction: column; */
  /* width: 100%; */
  /* align-items: center;
  justify-content: center; */
  /* width: 448px; */
  /* margin-left: 496px; */
`;

const Title = styled.div`
  width: ${(props) => (props.mobile ? '288px' : '328px')};
  text-align: ${(props) => (props.mobile ? 'center' : 'left')};
  height: 32px;
  margin-left: 16px;
  margin-right: 16px;
  ${(props) =>
    props.error
      ? css`
          margin-top: 0px;
        `
      : props.mobile
      ? css`
          margin-top: 80px;
        `
      : css`
          margin-top: 102px;
        `}

  font-size: 25px;
  font-weight: 600;
  color: #59616a;
`;

const SubTitle = styled.div`
  width: ${(props) => (props.mobile ? '288px' : 'auto')};
  text-align: ${(props) => (props.mobile ? 'center' : 'left')};
  height: 100%;
  margin: 16px 0 24px 16px;
  font-size: 15px;
  line-height: 1.6;
  color: #969ba1;
`;

const Avatar = styled.div`
  display: flex;
  /* min-width: 424px; */
`;

const P = styled.p`
  display: inline-block;
  width: ${(props) => props.width};
  margin: 0 16px 16px;
  /* height: 48px; */
  margin-top: 16px;
  margin-left: 16px;
  font-size: 15px;
  line-height: 1.6;
  color: #59616a;
  display: flex;
  align-items: center;

  font-family: 'Source Sans Pro';
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
`;

const PhoneHint = styled.div`
  width: ${(props) => (props.isTabletOrDesktop ? '448px' : '320px')};
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 4px;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transform: translateY(${(props) => (props.isVisible ? '0' : '-10px')});
  max-height: ${(props) => (props.isVisible ? '40px' : '0')};
  margin-top: ${(props) => (props.isVisible ? '12px' : '0')};
  margin-bottom: ${(props) => (props.isVisible ? '4px' : '0')};
  overflow: hidden;
  transition: 
    opacity 0.4s ease-out, 
    transform 0.4s ease-out,
    max-height 0.4s ease-out,
    margin-top 0.4s ease-out,
    margin-bottom 0.4s ease-out;
  pointer-events: ${(props) => (props.isVisible ? 'auto' : 'none')};
`;

const PulsingDot = styled.span`
  width: 8px;
  height: 8px;
  background-color: ${(props) => props.themeColor || '#ff6b35'};
  border-radius: 50%;
  animation: pulse 1.5s ease-in-out infinite;

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.5;
      transform: scale(0.8);
    }
  }
`;

const HintText = styled.span`
  font-size: 13px;
  color: #969ba1;
  font-weight: 400;
`;

const PhoneInputWrapper = styled.div`
  .react-tel-input .form-control,
  .react-tel-input input[type="tel"] {
    transition: border-color 0.3s ease, box-shadow 0.3s ease !important;
  }

  &.highlight .react-tel-input .form-control,
  &.highlight .react-tel-input input[type="tel"] {
    border-color: ${(props) => props.themeColor || '#ff6b35'} !important;
    box-shadow: 0 0 0 3px ${(props) => (props.themeColor || '#ff6b35')}40 !important;
  }
`;

const SignupForm = ({
  form,
  language,
  onChange,
  onSelect,
  onChangeImage,
  disabled,
  imgRef,
  coverImgRef,
  onMouseOver,
  onMouseOut,
  onDeleteClick,
  imgSrc,
  onSubmit,
  error,
  onBackButtonEvent,
  onFocusOut,
  onVerifyPhoneClick,
  isPhoneVerified,
  isLoaded,
  odm,
  phoneCountryCode,
  setPhoneCountryCode,
  verificationChannel,
  setVerificationChannel,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isTabletOrDesktop = TabletOrDesktop();
  const mobileButtonMaxWidth = '320px';
  const isHCloud = odm.name === 'HCLOUD';
  
  const [countryCode, setCountryCode] = useState();
  const countryRef = useRef(null);
  const [highlightPhone, setHighlightPhone] = useState(false);
  const [showHint, setShowHint] = useState(false);
  
  const previousFieldsFilled =
    form.username &&
    form.password &&
    form.passwordConfirm &&
    form.first_name &&
    form.last_name;
  
  const fieldsBeforePhoneFilled =
    previousFieldsFilled &&
    form.address &&
    form.role &&
    form.institution;
  
  const requiredFieldsFilled =
    previousFieldsFilled &&
    form.role &&
    form.country;
  
  const excludedCountries = ['CR', 'DZ', 'LB', 'IR']; // Country dropdown
  const excludedPhoneCountries = []; // Phone flag
  
  const verifyDisabledPhoneCountries = ['cr', 'dz', 'lb', 'ir'];
  const isCountryExcluded = excludedCountries.includes(form.country);
  const isPhoneCountryExcluded = verifyDisabledPhoneCountries.includes(phoneCountryCode);
  
  const shouldShowVerifyButton = isHCloud && !isCountryExcluded && !isPhoneCountryExcluded;
  
  const needsPhoneVerification = shouldShowVerifyButton;
  
  const isVerifyButtonDisabled = !previousFieldsFilled || !form.phone || isPhoneVerified;
  
  const isButtonDisabled = isHCloud 
    ? !requiredFieldsFilled || (needsPhoneVerification && !isPhoneVerified)
    : false;

  // TODO: ADD 2FA 
  // const handleTwoFactorChange = (e) => {
  //   const { name, checked } = e.target;
  //   onChange({
  //     target: {
  //       name,
  //       value: checked ? 2 : 0,
  //     },
  //   });
  // };

  const countryLocale = registerCountryLocale(language);

  // TODO : ADD 2FA
  // useEffect(() => {
  //   // Set 2FA to be enabled by default when country is US
  //   if (form.country === 'US' && form.two_factor_method === undefined) {
  //     onChange({
  //       target: {
  //         name: 'two_factor_method',
  //         value: 1,
  //       },
  //     });
  //   }
  // }, [form.country, form.two_factor_method, onChange]);

  useEffect(() => {
    if (form.country) {
      setCountryCode(form.country);
    }
  }, [form.country]);

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', onBackButtonEvent);

    const ipInfo = async () => {
      const res = await getIpInfo();
      if (res.data) setCountryCode(res.data.country_code);
    };
    ipInfo();

    return () => {
      window.removeEventListener('popstate', onBackButtonEvent);
      dispatch(initializeForm('authError'));
    };
  }, []);

  useEffect(() => {
    if (countryCode) {
      const country_name = countries.getName(countryCode, countryLocale);
      countryRef.current?.setValue(country_name);
      onSelect(countryCode, 'country');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode]);

  const handleVerifyClick = (e) => {
    e.preventDefault();
    onVerifyPhoneClick();
  };

  const handleChannelToggle = (position) => {
    setVerificationChannel(position === 'left' ? 'whatsapp' : 'sms');
  };

  const showPhonePrompt = fieldsBeforePhoneFilled && isHCloud && !form.phone;

  useEffect(() => {
    if (showPhonePrompt) {
      setShowHint(true);
      setHighlightPhone(true);
      const timer = setTimeout(() => {
        setHighlightPhone(false);
      }, 8000); 
      return () => clearTimeout(timer);
    } else {
      const hideTimer = setTimeout(() => {
        setShowHint(false);
      }, 400);
      return () => clearTimeout(hideTimer);
    }
  }, [showPhonePrompt]);

  return (
    <Container className={countryCode === 'US' ? 'us-country' : ''}>
      {isTabletOrDesktop && <Logo />}
      {!isTabletOrDesktop && <MobileTop></MobileTop>}
      <ContentContainer>
        <Content maxWidth={isTabletOrDesktop ? '448px' : mobileButtonMaxWidth}>
          <ErrorList error={error}></ErrorList>
          <Title style={{ fontWeight: '600', marginTop: '0' }} error={error} mobile={!isTabletOrDesktop}>
            {t('Create New Account')}
          </Title>
          <SubTitle mobile={!isTabletOrDesktop}>
            {t('Enter your details below and click "Create Account".')}
            <br />
            {t('*All fields are mandatory.')}
          </SubTitle>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit();
            }}
          >
            <Input
              width={isTabletOrDesktop ? '416px' : '288px'}
              type="email"
              name="username"
              id="username"
              margin="0"
              placeholder={t('Email Address*')}
              value={form.username}
              autoComplete="email"
              onChange={onChange}
              onBlur={onFocusOut}
              tabIndex={1}
              required
            />
            <ValidateDiv name="usernameValidate"></ValidateDiv>
            <Input
              width={isTabletOrDesktop ? '416px' : '288px'}
              type="password"
              name="password"
              margin="0"
              placeholder={t('Password*')}
              value={form.password}
              onChange={onChange}
              onBlur={onFocusOut}
              tabIndex={2}
              required
              autoComplete="new-password"
            />
            <ValidateDiv name="passwordValidate"></ValidateDiv>
            <Input
              width={isTabletOrDesktop ? '416px' : '288px'}
              type="password"
              name="passwordConfirm"
              margin="0"
              placeholder={t('Confirm Password*')}
              value={form.passwordConfirm}
              onChange={onChange}
              onBlur={onFocusOut}
              tabIndex={3}
              required
              autoComplete="new-password"
            />
            <ValidateDiv name="password_confirmValidate"></ValidateDiv>
            <Input
              width={isTabletOrDesktop ? '416px' : '288px'}
              type="text"
              name="first_name"
              id="first_name"
              margin="0"
              placeholder={t('First Name*')}
              value={form.first_name}
              onChange={onChange}
              onBlur={onFocusOut}
              tabIndex={4}
              required
              autoComplete="given-name"
            />
            <ValidateDiv name="first_nameValidate"></ValidateDiv>
            <Input
              width={isTabletOrDesktop ? '416px' : '288px'}
              type="text"
              name="last_name"
              id="last_name"
              margin="0"
              placeholder={t('Last Name*')}
              value={form.last_name}
              onChange={onChange}
              onBlur={onFocusOut}
              tabIndex={5}
              required
              autoComplete="family-name"
            />
            <ValidateDiv name="last_nameValidate"></ValidateDiv>
            {/* Address */}
            {isLoaded ? (
              <AddressAutocomplete
                value={form.address}
                onChange={onChange}
                onBlur={onFocusOut}
                isTabletOrDesktop={isTabletOrDesktop}
                tabIndex={6}
              />
            ) : (
              <Input
                as="textarea"
                style={{ resize: 'none', overflow: 'hidden' }}
                name="address"
                height="66px"
                width={isTabletOrDesktop ? '416px' : '288px'}
                margin="0"
                padding="14px 15px 14px 15px"
                placeholder={t('Address*')}
                value={form.address}
                onChange={onChange}
                onBlur={onFocusOut}
                tabIndex={6}
                maxLength={200}
              />
            )}
            <ValidateDiv name="addressValidate"></ValidateDiv>
            {/* Institution Type */}
            <DropdownList
              name="role"
              width={isTabletOrDesktop ? '448px' : mobileButtonMaxWidth}
              height="48px"
              placeholder={t('Institution Type*')}
              margin="8px 0 0 0"
              img_margin="12px 12px 12px 0"
              search={true}
              items={['Dental Clinic', 'Dental Lab', 'Dealer', 'Other']}
              onSelect={onSelect}
              zIndex={3}
              tabIndex={7}
              required
            />
            <ValidateDiv name="roleValidate"></ValidateDiv>
            {/* Institution Name */}
            <Input
              name="institution"
              width={isTabletOrDesktop ? '416px' : '288px'}
              margin="0"
              placeholder={t('Institution Name*')}
              value={form.institution}
              onChange={onChange}
              onBlur={onFocusOut}
              maxLength={100}
              tabIndex={8}
            />
            <ValidateDiv name="institutionValidate"></ValidateDiv>
            {/* Country */}
            <DropdownList
              name="country"
              width={isTabletOrDesktop ? '448px' : mobileButtonMaxWidth}
              height="48px"
              maxHeight="216px"
              placeholder={t('Country*')}
              defaultValue={countries.getName(countryCode, countryLocale)}
              margin="8px 0 0 0"
              img_margin="12px 12px 12px 0"
              search={true}
              items={Object.fromEntries(
                Object.entries(countries.getNames(countryLocale, { select: 'official' })).sort(function (
                  [, a],
                  [, b],
                ) {
                  return a.localeCompare(b);
                }),
              )}
              onSelect={onSelect}
              zIndex={2}
              tabIndex={9}
              required
              ref={countryRef}
            />
            <ValidateDiv name="countryValidate"></ValidateDiv>
            
            {/* Phone Hint */}
            {(showPhonePrompt || showHint) && (
              <PhoneHint isTabletOrDesktop={isTabletOrDesktop} isVisible={showPhonePrompt}>
                <PulsingDot themeColor={odm.theme_color} />
                <HintText>{t('Enter your phone number below')}</HintText>
              </PhoneHint>
            )}
            
            {/* Phone */}
            <PhoneInputWrapper 
              className={highlightPhone ? 'highlight' : ''} 
              themeColor={odm.theme_color}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: isTabletOrDesktop ? '448px' : '320px',
                  margin: '8px auto 0',
                  justifyContent: 'space-between',
                }}
              >
                <PhoneInput
                  country={countryCode ? countryCode.toLowerCase() : 'us'}
                  value={form.phone}
                  onChange={(value, data, event, formattedValue) => {
                    if (setPhoneCountryCode) {
                      setPhoneCountryCode(data.countryCode);
                    }
                    onChange({
                      target: {
                        name: 'phone',
                        value: value.startsWith('+') ? value : `+${value}`,
                      },
                    });
                  }}
                  inputProps={{
                    tabIndex: 11,
                  }}
                  inputStyle={{
                    width: shouldShowVerifyButton 
                      ? (isTabletOrDesktop ? '348px' : '210px') 
                      : (isTabletOrDesktop ? '448px' : '320px'),                    
                    height: '48px',
                    border: '1px solid #eeeff0',
                    background: '#fff',
                    borderRadius: '5px',
                    fontSize: '14px',
                    color: '#59616a',
                  }}
                  disabled={isPhoneVerified}
                  enableSearch
                  excludeCountries={excludedPhoneCountries}
                />
                {shouldShowVerifyButton && (
                  <Button
                    type="button"
                    width="100%"
                    height="48px"
                    margin="0"
                    onClick={handleVerifyClick}
                    disabled={isVerifyButtonDisabled}
                    style={{ 
                      pointerEvents: isPhoneVerified ? 'none' : 'auto',
                      backgroundColor: !isVerifyButtonDisabled ? odm.theme_color : undefined,
                      borderColor: !isVerifyButtonDisabled ? odm.theme_color : undefined,
                      borderRadius: '4px',
                    }}
                  >
                    {isPhoneVerified ? t('Verified') : t('Verify')}
                  </Button>
                )}
              </div>
            </PhoneInputWrapper>
            
            {/* Toggle WhatsApp/SMS et message */}
            {shouldShowVerifyButton && !isPhoneVerified && (
              <div
                style={{
                  width: isTabletOrDesktop ? '448px' : '320px',
                  margin: '12px auto 0',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <ToggleSwitch
                  leftLabel="WhatsApp"
                  rightLabel="SMS"
                  leftIcon="💬"
                  rightIcon="📱"
                  value={verificationChannel === 'whatsapp' ? 'left' : 'right'}
                  onChange={handleChannelToggle}
                />
                <p
                  style={{
                    fontSize: '11px',
                    color: '#969ba1',
                    margin: 0,
                    textAlign: 'center',
                  }}
                >
                  {t('*If WhatsApp fails, we will automatically send an SMS')}
                </p>
              </div>
            )}

            <Avatar>
              <ImageButton
                social_auth={false}
                style={{ marginTop: 8, marginLeft: 8 }}
                src={imgSrc}
                tabIndex={11}
                disabled={disabled}
                imgRef={imgRef}
                coverImgRef={coverImgRef}
                onChangeImage={onChangeImage}
                onMouseOver={onMouseOver}
                onMouseOut={onMouseOut}
                onDeleteClick={onDeleteClick}
              />
              <P width={isTabletOrDesktop ? '344px' : '216px'}>
                {t(
                  'Upload an image so your connections can easily recognize your cases (Optional)',
                )}
              </P>
            </Avatar>
            <Button
              width={isTabletOrDesktop ? '448px' : '320px'}
              data-action="submit"
              margin={isTabletOrDesktop ? '24px 0 0px 0' : '24px 0 80px 0'}
              tabIndex={12}
              disabled={isButtonDisabled}
              style={{ 
                backgroundColor: !isButtonDisabled && odm.theme_color, 
                borderColor: !isButtonDisabled && odm.theme_color 
              }}
            >
              {t('Activate').toUpperCase()}
            </Button>
            
          </form>
        </Content>
      </ContentContainer>
    </Container>
  );
};

export default React.memo(SignupForm);
